module.exports = __webpack_public_path__ + "static/media/mobile_cast.5fc01f15.svg";